const AppSyncConfig = {
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_API_URL,
  aws_appsync_region: process.env.REACT_APP_API_REGION,
  aws_appsync_authenticationType: process.env.REACT_APP_AUTH_TYPE,
  aws_appsync_apiKey: process.env.REACT_APP_API_KEY,
};

export default AppSyncConfig;
